export type Timestamp = string | number | Date;

// Backend timestamps without an offset are UTC; numeric device timestamps are milliseconds.
export function parseTimestamp(value: Timestamp): Date {
    if (typeof value !== 'string') return new Date(value instanceof Date ? value.getTime() : value);
    const normalized = value.trim().replace(' ', 'T');
    const hasOffset = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized);
    return new Date(hasOffset ? normalized : `${normalized.length === 10 ? `${normalized}T00:00:00` : normalized}Z`);
}

export function timezoneLabel(offsetMinutes: number): string {
    const absolute = Math.abs(offsetMinutes);
    const minutes = absolute % 60;
    return `UTC${offsetMinutes < 0 ? '-' : '+'}${Math.floor(absolute / 60)}${minutes ? `:${String(minutes).padStart(2, '0')}` : ''}`;
}

export function formatTraderDate(value: Timestamp | null | undefined, offsetMinutes = 0): string {
    if (value == null || value === '') return '—';
    const date = parseTimestamp(value);
    if (!Number.isFinite(date.getTime())) return '—';
    return new Date(date.getTime() + offsetMinutes * 60000).toLocaleString('ru-RU', { timeZone: 'UTC' });
}

// A datetime-local/date input is a wall-clock value in the selected fixed offset.
export function traderInputToUTC(value: string, offsetMinutes: number): Date {
    return new Date(parseTimestamp(value).getTime() - offsetMinutes * 60000);
}

export function traderDateKey(value: Timestamp, offsetMinutes: number): string {
    return new Date(parseTimestamp(value).getTime() + offsetMinutes * 60000).toISOString().slice(0, 10);
}

// Legacy API error messages can contain an explicitly marked UTC deadline.
export function formatTraderMessage(message: string, offsetMinutes: number): string {
    return message.replace(/\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z? \(UTC\)/g,
        value => `${formatTraderDate(value.replace(' (UTC)', ''), offsetMinutes)} ${timezoneLabel(offsetMinutes)}`);
}
